import { FC, useMemo } from 'react';
// i18next
import i18n from 'i18n';
import { useTranslation } from 'react-i18next';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
// Router
import { push } from 'connected-react-router';
// Models
import IQuiz from 'models/Quiz';
// Types
import QuizTypes from 'types/QuizTypes';
// Actions
import { appActions } from 'store/app/appSlice';
// Selectors
import { selectQuiz } from 'store/quiz/quizzesSelectors';
// MUI
import { Tabs as MuiTabs, Tab as MuiTab, useMediaQuery } from '@material-ui/core';

type Props = {
  activeTab: string;
}

const Tabs:FC<Props> = ({
  // Props
  activeTab
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const isLaptop = useMediaQuery('(min-width: 1024px) and (max-width: 1280px)');

  const quiz:IQuiz | null = useAppSelector(selectQuiz);

  const handleClick = (nextTab:string) => () => {
    dispatch(push({ search: `tab=${nextTab}` }));
  }

  const handleTogglePreview = () => {
    dispatch(appActions.toggleQuizFormPreview())
  }

  if (!quiz) return null;

  // eslint-disable-next-line
  const tabs = useMemo(() => {
    return [
      { value: 'quiz', label: t('pages.quizForm.tabs.gameFeatures') },
      { value: 'pages', label: t('pages.quizForm.tabs.pages') },
      { value: 'liveLeaderboard', label: [QuizTypes.Poll, QuizTypes.RankingPoll, QuizTypes.TeamSelector].includes(quiz.type) ? t('pages.quizForm.tabs.liveResults') : t('pages.quizForm.tabs.liveLeaderboard'), hidden: [QuizTypes.Personality, QuizTypes.Survey].includes(quiz.type) },
      { value: 'postQuizPages', label: t('pages.quizForm.tabs.personalizedResults'), hidden: [QuizTypes.Scoring, QuizTypes.Prediction, QuizTypes.Poll, QuizTypes.Survey, QuizTypes.RankingPoll, QuizTypes.TeamSelector, QuizTypes.BeatTheExpert, QuizTypes.Streak].includes(quiz.type) },
      { value: 'correctAnswers', label: t('pages.quizForm.tabs.correctAnswers'), hidden: [QuizTypes.Scoring, QuizTypes.Personality, QuizTypes.Poll, QuizTypes.Survey, QuizTypes.RankingPoll, QuizTypes.TeamSelector, QuizTypes.BeatTheExpert, QuizTypes.Streak].includes(quiz.type) },
    ];
    // eslint-disable-next-line
  }, [i18n.language]);

  return (
    <div className="mb-6 flex items-center">
      <MuiTabs value={activeTab} variant="scrollable">
        {tabs.map((tab:any) => {
          if (tab.hidden) return null;
          return (
            <MuiTab
              key={`tab-${tab.value}`}
              label={tab.label}
              onClick={handleClick(tab.value)}
              value={tab.value}
              style={{
                fontSize: '16px',
                textTransform: 'capitalize',
                color: activeTab === tab.value ? '#FF9000' : '#ffffff99'
              }}
            />
          )
        })}
        <MuiTab
          label={t('buttons.preview')}
          onClick={handleTogglePreview}
          style={{
            display: isLaptop ? 'initial' : 'none',
            fontSize: '16px',
            textTransform: 'capitalize',
            color: '#ffffff99'
          }}
        />
      </MuiTabs>
    </div>
  )
}

export default Tabs;
